/* ARCHIVE theme — global behaviour (no dependencies) */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const store = {
    get(k, d) { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const fmt = (window.theme && theme.moneyFormat) || '${{amount}}';
    const n = (cents / 100);
    const withDelims = (num, dec, t = ',', d = '.') => {
      const parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts.join(d);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return withDelims(n, 0);
      if (k === 'amount_with_comma_separator') return withDelims(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withDelims(n, 0, '.', ',');
      return withDelims(n, 2);
    });
  }
  window.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  function toast(msg) {
    const t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('is-visible'), 2400);
  }

  /* ---------- Drawers / overlays ---------- */
  let lastFocus = null;
  function openPanel(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const f = el.querySelector('input:not([type=hidden]), button, a[href]');
    f && setTimeout(() => f.focus(), 50);
  }
  function closePanel(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .modal.is-open, .search-overlay.is-open, .lightbox.is-open')) document.body.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  window.openPanel = openPanel; window.closePanel = closePanel;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const target = $(opener.dataset.open);
      if (target) {
        if (opener.dataset.open === '#CartDrawer' && document.body.dataset.cartType === 'page') return;
        e.preventDefault(); openPanel(target);
      }
    }
    const closer = e.target.closest('[data-close]');
    if (closer) { e.preventDefault(); closePanel(closer.closest('.drawer, .modal, .search-overlay, .lightbox')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open, .modal.is-open, .search-overlay.is-open, .lightbox.is-open').forEach(closePanel);
    if (e.key === '/' && !/input|textarea|select/i.test(document.activeElement.tagName)) {
      const s = $('#SearchOverlay'); if (s) { e.preventDefault(); openPanel(s); }
    }
  });

  /* ---------- Header: hide on scroll down, measure height ---------- */
  const headerWrap = $('.header-wrap');
  if (headerWrap) {
    const setVars = () => {
      const r = headerWrap.getBoundingClientRect();
      document.documentElement.style.setProperty('--header-h', r.height + 'px');
      document.documentElement.style.setProperty('--header-bottom', Math.max(r.bottom, 0) + 'px');
    };
    setVars(); window.addEventListener('resize', setVars);
    if (headerWrap.dataset.autohide === 'true') {
      let y0 = window.scrollY;
      window.addEventListener('scroll', () => {
        const y = window.scrollY;
        headerWrap.classList.toggle('is-hidden', y > y0 && y > 200);
        y0 = y; setVars();
      }, { passive: true });
    } else {
      window.addEventListener('scroll', setVars, { passive: true });
    }
  }

  /* ---------- Cart ---------- */
  const Cart = {
    async add(items) {
      const res = await fetch(theme.routes.cart_add_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Error');
      await Cart.refresh(true);
      return data;
    },
    async change(line, quantity) {
      const res = await fetch(theme.routes.cart_change_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      if (!res.ok) { const d = await res.json(); toast(d.description || d.message); }
      await Cart.refresh(false);
    },
    async refresh(open) {
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      const [cart, html] = await Promise.all([
        fetch(theme.routes.cart_url + '.js').then(r => r.json()),
        fetch(theme.routes.root_url.replace(/\/$/, '') + '/?section_id=cart-drawer').then(r => r.text())
      ]);
      $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('#CartDrawerInner');
      const cur = $('#CartDrawerInner');
      if (fresh && cur) cur.replaceWith(fresh);
      if (open) {
        if (document.body.dataset.cartType === 'page') { toast(theme.strings.added); }
        else openPanel($('#CartDrawer'));
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    }
  };
  window.ArchiveCart = Cart;

  // Product form submit (AJAX)
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    const fd = new FormData(form);
    const id = fd.get('id');
    if (!id) { toast(theme.strings.unavailable); return; }
    const item = { id: Number(id), quantity: Number(fd.get('quantity') || 1) };
    const props = {}; for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; }
    if (Object.keys(props).length) item.properties = props;
    btn && btn.setAttribute('aria-busy', 'true');
    try { await Cart.add([item]); }
    catch (err) { toast(err.message); }
    finally { btn && btn.removeAttribute('aria-busy'); }
  });

  // Quick add from cards (one-tap size)
  document.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-quick-add]');
    if (!q) return;
    e.preventDefault();
    try { await Cart.add([{ id: Number(q.dataset.quickAdd), quantity: 1 }]); }
    catch (err) { toast(err.message); }
  });

  // Cart drawer / page line controls
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    Cart.change(Number(b.dataset.line), Number(b.dataset.lineChange));
  });
  document.addEventListener('change', (e) => {
    const i = e.target.closest('[data-line-qty]');
    if (i) Cart.change(Number(i.dataset.line), Math.max(0, Number(i.value)));
    const n = e.target.closest('[data-cart-note]');
    if (n) fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: n.value }) });
  });

  /* ---------- Quantity steppers (product page) ---------- */
  document.addEventListener('click', (e) => {
    const s = e.target.closest('[data-qty-step]');
    if (!s) return;
    const input = s.parentElement.querySelector('input');
    input.value = Math.max(1, Number(input.value || 1) + Number(s.dataset.qtyStep));
  });

  /* ---------- Predictive search ---------- */
  const sInput = $('#SearchOverlayInput');
  if (sInput) {
    let t;
    sInput.addEventListener('input', () => {
      clearTimeout(t);
      const q = sInput.value.trim();
      const out = $('#SearchOverlayResults');
      if (q.length < 2) { out.innerHTML = ''; return; }
      t = setTimeout(async () => {
        const url = `${theme.routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page&resources[limit]=8&section_id=predictive-search`;
        const html = await fetch(url).then(r => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('#PredictiveResults');
        out.innerHTML = inner ? inner.innerHTML : '';
      }, 220);
    });
  }

  /* ---------- Countdowns ---------- */
  $$('[data-countdown]').forEach(el => {
    const end = new Date(el.dataset.countdown).getTime();
    if (isNaN(end)) { el.hidden = true; return; }
    const pad = n => String(n).padStart(2, '0');
    const tick = () => {
      let s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      const d = Math.floor(s / 86400); s -= d * 86400;
      const h = Math.floor(s / 3600); s -= h * 3600;
      const m = Math.floor(s / 60); s -= m * 60;
      el.innerHTML = `<span><b>${pad(d)}</b>DAYS</span><span><b>${pad(h)}</b>HRS</span><span><b>${pad(m)}</b>MIN</span><span><b>${pad(s)}</b>SEC</span>`;
      if (end - Date.now() <= 0 && el.dataset.doneText) { el.innerHTML = `<span><b>${el.dataset.doneText}</b></span>`; clearInterval(iv); }
    };
    tick(); const iv = setInterval(tick, 1000);
  });

  /* ---------- Collection grid density toggle ---------- */
  document.addEventListener('click', (e) => {
    const g = e.target.closest('[data-grid-cols]');
    if (!g) return;
    const grid = $('#ProductGrid'); if (!grid) return;
    grid.style.setProperty('--cols-d', g.dataset.gridCols);
    grid.style.setProperty('--cols-m', g.dataset.gridColsMobile);
    $$('[data-grid-cols]').forEach(b => b.setAttribute('aria-pressed', b === g));
    store.set('archive:grid', g.dataset.gridCols);
  });
  const savedCols = store.get('archive:grid', null);
  if (savedCols) { const b = $(`[data-grid-cols="${savedCols}"]`); b && b.click(); }

  // Auto-submit filters & sort
  document.addEventListener('change', (e) => {
    const f = e.target.closest('form[data-autosubmit]');
    if (f && !e.target.matches('input[type=number]')) f.requestSubmit ? f.requestSubmit() : f.submit();
  });

  /* ---------- Size guide unit toggle ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-unit]');
    if (!b) return;
    const wrap = b.closest('[data-size-guide]');
    const unit = b.dataset.unit;
    $$('[data-unit]', wrap).forEach(x => x.setAttribute('aria-pressed', x === b));
    $$('[data-in]', wrap).forEach(td => {
      const v = td.dataset.in;
      td.textContent = unit === 'cm'
        ? v.replace(/(\d+(?:\.\d+)?)/g, n => (Math.round(parseFloat(n) * 2.54 * 10) / 10).toString())
        : v;
    });
    store.set('archive:unit', unit);
  });
  if (store.get('archive:unit') === 'cm') { const b = $('[data-unit="cm"]'); b && b.click(); }

  /* ---------- Recently viewed (client-side, no extra requests) ---------- */
  const rvData = $('#RecentlyViewedData');
  if (rvData) {
    try {
      const p = JSON.parse(rvData.textContent);
      let list = store.get('archive:rv', []).filter(x => x.url !== p.url);
      list.unshift(p); store.set('archive:rv', list.slice(0, 12));
    } catch (e) {}
  }
  $$('[data-recently-viewed]').forEach(wrap => {
    const current = rvData ? JSON.parse(rvData.textContent).url : null;
    const list = store.get('archive:rv', []).filter(x => x.url !== current).slice(0, Number(wrap.dataset.limit || 4));
    if (!list.length) { wrap.closest('section, .shopify-section').hidden = true; return; }
    const grid = wrap.querySelector('.grid');
    grid.innerHTML = list.map(p => `
      <div class="card">
        <a class="card__media" href="${p.url}">${p.image ? `<img class="card__img-1" src="${p.image}" alt="" loading="lazy" width="600" height="750">` : ''}</a>
        <div class="card__info"><a class="card__title" href="${p.url}">${p.title}</a><div class="card__price">${p.price}</div></div>
      </div>`).join('');
  });

  /* ---------- Expose ---------- */
  window.ArchiveUtils = { $, $$, toast, store };
})();
